import { getQueryParam } from "@/react/helpers/urlHelpers";
import { getPaywallPrice } from "../helpers/paywallPrices";
import type { CheckoutProps } from "../types/CheckoutProps";

export const useCheckoutPaywallPrice = ({ paywall }: CheckoutProps) => {
  let paywallPriceId: number | undefined;

  const queryPaywallPriceId = getQueryParam("price_id");
  if (queryPaywallPriceId) {
    const parsed = parseInt(queryPaywallPriceId, 10);
    if (!isNaN(parsed)) {
      paywallPriceId = parsed;
    }
  }

  return getPaywallPrice(paywall, paywallPriceId);
};
